var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifiedWhiteBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.88424 11.0872H2.23042C1.86113 11.0872 1.56183 10.7879 1.56183 10.4186V8.76416C1.56183 8.58684 1.49117 8.41686 1.36585 8.29154L0.195978 7.12167C-0.0653261 6.86037 -0.0653261 6.43708 0.195978 6.17644L1.37785 4.99457C1.49583 4.87659 1.56183 4.71727 1.56183 4.55062V2.88081C1.56183 2.51152 1.86113 2.21222 2.23042 2.21222H3.8849C4.06222 2.21222 4.2322 2.14156 4.35752 2.01624L5.52739 0.846369C5.78869 0.585065 6.21198 0.585065 6.47261 0.846369L7.64248 2.01624C7.7678 2.14156 7.93778 2.21222 8.1151 2.21222H9.76958C10.1389 2.21222 10.4382 2.51152 10.4382 2.88081V4.53529C10.4382 4.71261 10.5088 4.88259 10.6342 5.00791L11.804 6.17778C12.0653 6.43908 12.0653 6.86237 11.804 7.123L10.6342 8.29287C10.5088 8.41819 10.4382 8.58818 10.4382 8.76549V10.42C10.4382 10.7893 10.1389 11.0886 9.76958 11.0886H8.1151C7.93778 11.0886 7.7678 11.1592 7.64248 11.2845L6.47261 12.4544C6.21131 12.7157 5.78802 12.7157 5.52739 12.4544L4.35752 11.2845C4.23153 11.1572 4.06155 11.0872 3.88424 11.0872Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 5.40039L5.49983 8.15011L4.25 6.90039",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.40039L5.49983 8.15011L4.25 6.90039",
    stroke: "#323232",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedWhiteBadge);
export default __webpack_public_path__ + "static/media/verified-white-badge.77a4f4deaef856391c11e5e10b5b76a2.svg";
export { ForwardRef as ReactComponent };